import styled from 'styled-components'

const FilterValueGroup = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 10px;
`

export default FilterValueGroup
